<template>
  <div data-testid="check-list-comment-editor">
    <SfMarkdownEditor
      ref="editorRef"
      :model-value="initialText"
      :mention-usernames="[]"
      :mention-accounts="[]"
      :mention-recon-templates="[]"
      :disable-mentions="true"
      :placeholder="placeholder"
      @update:model-value="updateText"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

import SfMarkdownEditor from '@app/shared/vue/components/sf-markdown-editor/sf-markdown-editor.vue'

interface Props {
  initialText: string
  placeholder: string
  // Avoid an on* prefix — Vue strips on* keys from props as event listeners.
  updateText: (value: string) => void
}

defineProps<Props>()

const editorRef = ref<InstanceType<typeof SfMarkdownEditor> | null>(null)

onMounted(() => {
  editorRef.value?.autoFocus()
})
</script>
